module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n         " + _vm._s(_vm.$t('static.products.index.title')) + " (" + _vm._s(_vm.products.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "listOptions pull-right"
  }, [_c('v-text', {
    staticClass: "searchForm",
    attrs: {
      "name": "search",
      "type": "text",
      "translation": "search.title",
      "value": _vm.search,
      "clearable": true
    },
    on: {
      "keydown": _vm.onChangeSearch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block product-filter",
    staticStyle: {
      "width": "320px",
      "float": "right"
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": _vm.$t('static.products.filters.placeholder'),
      "options": _vm.filters,
      "clearable": ""
    },
    on: {
      "change": _vm.handleFilterChange
    },
    model: {
      value: (_vm.filterValue),
      callback: function($$v) {
        _vm.filterValue = $$v
      },
      expression: "filterValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "listOptions pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": _vm.primary,
      "size": "small",
      "icon": "el-icon-download",
      "round": ""
    },
    on: {
      "click": _vm.showImportDownloadModal
    }
  }, [_vm._v(_vm._s(_vm.$t('button.downloadImport')) + "\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.info,
      "size": "small",
      "icon": "el-icon-setting",
      "circle": ""
    },
    on: {
      "click": _vm.showProductIndexSettingsModal
    }
  })], 1)], 1)])], 1), _vm._v(" "), (_vm.showAction) ? _c('el-row', {
    staticClass: "bulkActions",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6,
      "xl": 4
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedCount) + " products selected")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "md": 3,
      "lg": 3,
      "xl": 2
    }
  }, [(_vm.showAction) ? _c('label', [_vm._v(_vm._s(_vm.$t('productActions.select.label')) + " ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 13,
      "lg": 15,
      "xl": 18
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default small",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSelectAction('activateProduct')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('productActions.activateProduct')))]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--danger danger small",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSelectAction('deactivateProduct')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('productActions.deactivateProduct')))]), _vm._v(" "), (_vm.hasWooModule) ? _c('button', {
    staticClass: "el-button el-button--default small",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSelectAction('syncToWoo')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('productActions.syncToWoo')))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', [(_vm.products.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.product.noDataMsg')) + "\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'products.create'
      }
    }
  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.product.noDataBtn')) + "\n          ")])], 1)], 1) : [(!_vm.searchQuery.grouping) ? _c('div', {
    staticClass: "flex stretch wrap"
  }, _vm._l((_vm.products.items), function(p, i) {
    return _c('v-card', {
      key: i,
      nativeOn: {
        "click": function($event) {
          return _vm.editProduct(p)
        }
      }
    }, [_c('label', {
      staticClass: "cardLabel w-full"
    }, [_c('span', {
      staticClass: "cardBadge"
    }, [_vm._v(_vm._s(_vm.$t(("static.products.types." + (_vm.camelize(p.productType))))))]), _vm._v(" "), (_vm.hasInventory && (!p.containsAlcohol && p.productTypeGroup === 'Beverage')) ? _c('span', {
      staticClass: "cardBadge card-yellow"
    }, [_vm._v(_vm._s(_vm.$t("static.products.labels.alcoholFree")))]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-external-link pull-right",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editProductNewTab(p)
        }
      }
    })]), _vm._v(" "), _c('h2', {
      staticClass: "cardTitle"
    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('form.products.price.label')) + ": ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.selectedPrice.toFixed(2)) + " NOK")]), _vm._v(" "), (p.description) ? _c('div', {
      staticClass: "cardinnerBox"
    }, [_c('div', [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_c('i', {
      staticClass: "fa fa-file-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" \n                  " + _vm._s(p.description))])])]) : _vm._e()])
  }), 1) : [_vm._l((_vm.productGroupedCardView), function(products, group) {
    return [(group !== 'none') ? _c('h2', {
      staticStyle: {
        "font-size": "18px",
        "font-weight": "bolder",
        "margin-bottom": "4px",
        "text-transform": "uppercase",
        "color": "#0b5470"
      }
    }, [_vm._v(_vm._s(_vm.searchQuery.grouping === 'Type' ? _vm.$t(("static.products.types." + (_vm.camelize(group)))) : group))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "flex stretch wrap"
    }, _vm._l((products), function(p, i) {
      return _c('v-card', {
        key: i,
        nativeOn: {
          "click": function($event) {
            return _vm.editProduct(p)
          }
        }
      }, [_c('label', {
        staticClass: "cardLabel"
      }, [_c('span', {
        staticClass: "cardBadge"
      }, [_vm._v(_vm._s(_vm.$t(("static.products.types." + (_vm.camelize(p.productType))))))]), _vm._v(" "), (!p.containsAlcohol && p.productTypeGroup === 'Beverage') ? _c('span', {
        staticClass: "cardBadge card-yellow"
      }, [_vm._v(_vm._s(_vm.$t("static.products.labels.alcoholFree")))]) : _vm._e(), _vm._v(" "), _c('i', {
        staticClass: "fa fa-external-link pull-right",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "aria-hidden": "true"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.editProductNewTab(p)
          }
        }
      })]), _vm._v(" "), _c('h2', {
        staticClass: "cardTitle"
      }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('label', {
        staticClass: "cardLabel"
      }, [_vm._v(_vm._s(_vm.$t('form.products.price.label')) + ": ")]), _c('span', {
        staticClass: "cardContent"
      }, [_vm._v(_vm._s(p.selectedPrice.toFixed(2)) + " NOK")]), _vm._v(" "), (p.description) ? _c('div', {
        staticClass: "cardinnerBox"
      }, [_c('div', [_c('label', {
        staticClass: "cardLabel cardLabel--small"
      }, [_c('i', {
        staticClass: "fa fa-file-o",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" \n                      " + _vm._s(p.description))])])]) : _vm._e()])
    }), 1)]
  })]]], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : [(!_vm.searchQuery.grouping) ? _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.productsListView
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "number",
      "label": _vm.$t('static.products.table.number'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.products.table.name'),
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editProduct(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 3795395497)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.products.table.price'),
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.price)
          }
        })]
      }
    }], null, false, 3236041401)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.products.table.warehouses'),
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.warehouses)
          }
        })]
      }
    }], null, false, 3400470626)
  })], 1) : [_vm._l((_vm.productGroupedListView), function(products, group) {
    return [(group !== 'none') ? _c('h2', {
      staticStyle: {
        "font-size": "18px",
        "font-weight": "bolder",
        "margin-bottom": "4px",
        "text-transform": "uppercase",
        "color": "#0b5470"
      }
    }, [_vm._v(_vm._s(_vm.searchQuery.grouping === 'Type' ? _vm.$t(("static.products.types." + (_vm.camelize(group)))) : group))]) : _vm._e(), _vm._v(" "), _c('v-table', {
      attrs: {
        "list": products,
        "noDataMessage": _vm.$t('static.defaultText.product.noDataMsg'),
        "link": _vm.editProduct,
        "linkKey": "name",
        "rowKey": "id",
        "translation": "static.products.table"
      }
    })]
  })]]], 2) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.products.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3759488f","hasScoped":true}!./src/app/pages/withNavigation/products/index/index.html
// module id = 2969
// module chunks = 1